const muiVariables = {
  primaryColor: "#FFFFFF",
  mainTextColor: "#0C0C0C",
  subTextColor: "#3D3D3D",
  accentTextColor: "#FF8600",
  linkTextColor: "#4FCE5D",
  primaryBtnColor: "#0A457A",
  disabledBtnColor: "#d3d3d3",
  secondaryBtnColor: "#1EA44B",
  errorMessageColor: "#d32f2f",
  deleteTextColor: "#FF443A",
  avatarBgColor: "#F7F7F7",
  borderColor: "#EBEBEB",
  notifyBgColor: "#ECF5FD",
  progressFillColor: "#91d6fb",
  dateFillColor: "#127CDB",
  thirdTextColor: "#575757",
  mainFontFamily: "Montserrat",
  drawerWidth: 250,
  mainHeadingFontSize: "16px",
  subHeadingFontSize: "14px",
  dashedBorderColor: "#196FF0"
};

export default muiVariables;
